import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { LastReviewValidationSchema } from '@/common/schemas/lastReview.schema'
import { FormTransformers } from '@/common/utils/formTransformers'
import { useUpdateMaintenanceDirectiveDiagnosticEntryLastReview } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/directive/diagnosticEntries/useUpdateMaintenanceDirectiveDiagnosticEntryLastReview'
import { useForwardingTabContext } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/useForwardingTabContext'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { SubmitHandler } from 'react-hook-form'
import { useParams } from 'react-router-dom'

const DirectiveEntryDiagnosticEntriesApprove = () => {
  const { forwarding } = useForwardingTabContext()

  const { id } = useParams()

  const queryClient = useQueryClient()

  const [isOpen, setIsOpen] = useState(false)

  const [messages, setMessages] = useState<string[] | boolean>(false)

  const { mutate: updateLastReview, isPending: updateLastReviewIsPending } =
    useUpdateMaintenanceDirectiveDiagnosticEntryLastReview({
      directiveEntryId: forwarding?.directive_entry?.id,
      options: {
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: ['maintenanceForwarding', forwarding.id],
          })

          queryClient.invalidateQueries({
            queryKey: ['maintenanceWorkflow', id],
          })

          setIsOpen(false)
        },
        onError: (error) => {
          FormTransformers.errorsTransformer({
            setMessages,
          })(error)
        },
      },
    })

  const onSubmit: SubmitHandler<LastReviewValidationSchema> = (data) => updateLastReview(data)

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={
          <Button
            variant="outline-error"
            operationKlassToCheckPermission="Admin::Maintenance::Directive::DiagnosticEntries::Update"
          >
            Remover revisão
          </Button>
        }
        title="Remover revisão"
        subtitle="Tem certeza que deseja remover a revisão deste diagnóstico e orçamento?"
        subtitleClassName="mt-1 text-md text-white-300"
        useCancellableFooter
        showClose={false}
        cancelButtonClassName="bg-white-100"
        confirmButtonClassName="bg-primary-blue"
        onConfirm={() => onSubmit({ state: 'approved', description: '' })}
        confirmButtonIsLoading={updateLastReviewIsPending}
      />

      <ModalMessageSimple messages={messages} setMessages={setMessages} isError />
    </>
  )
}

export default DirectiveEntryDiagnosticEntriesApprove
